export const formatAuditLabel = (value: string | null | undefined) => {
    if (!value) return "—";

    return value
        .replace(/([a-z])([A-Z])/g, "$1 $2")
        .replace(/[_-]+/g, " ")
        .toLowerCase()
        .replace(/\b\w/g, (character) => character.toUpperCase());
};

export const formatAuditDate = (
    value: string | null | undefined,
    style: "short" | "long" = "short"
) => {
    if (!value) return "—";

    return new Date(value).toLocaleString("en-NG", {
        dateStyle: style === "long" ? "long" : "medium",
        timeStyle: "short",
    });
};

export const formatAuditDay = (value: string | null | undefined) => {
    if (!value) return "—";

    return new Date(value).toLocaleDateString("en-NG", {
        day: "numeric",
        month: "short",
        year: "numeric",
    });
};

export const formatAuditRole = (value: string | null | undefined) =>
    formatAuditLabel(value);

export const formatAdminIdentity = (
    email: string | null | undefined,
    id?: string | null
) => email || id || "Unknown admin";

export const AUDIT_STATUS_CLASSES: Record<string, string> = {
    SUCCESS: "bg-emerald-100 text-emerald-700 dark:bg-emerald-900/30 dark:text-emerald-400",
    FAILURE: "bg-rose-100 text-rose-700 dark:bg-rose-900/30 dark:text-rose-400",
    PARTIAL: "bg-amber-100 text-amber-700 dark:bg-amber-900/30 dark:text-amber-400",
    DENIED: "bg-red-100 text-red-700 dark:bg-red-900/30 dark:text-red-400",
};

export const formatPercent = (value: number | null | undefined) =>
    value == null || Number.isNaN(value) ? "—" : `${value.toFixed(1)}%`;
